import produce from "immer";
import {
	CLEAR_COMPANY_OUTLET_ADDRESS_STATE,
	CLEAR_COMPANY_OUTLET_ADDRESS,
	FETCH_COMPANY_OUTLET_ADDRESS_FAILED,
	FETCH_COMPANY_OUTLET_ADDRESS_LIST_FAILED,
	FETCH_COMPANY_OUTLET_ADDRESS_LIST_PROGRESS,
	FETCH_COMPANY_OUTLET_ADDRESS_LIST_SUCCESS,
	FETCH_COMPANY_OUTLET_ADDRESS_PROGRESS,
	FETCH_COMPANY_OUTLET_ADDRESS_SUCCESS,
	initialCompanyOutletAddress,
	initialCompanyOutletAddressState,
} from ".";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";

export const companyOutletAddressReducer = (
	state: IStoreState["companyOutletAddress"] = initialCompanyOutletAddressState,
	action: any
) => {
	switch (action.type) {
		case FETCH_COMPANY_OUTLET_ADDRESS_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.InProgress;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ADDRESS_LIST_SUCCESS: {
			const { data, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.list = data;
				draftState.list.totalRecords = totalRecords;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ADDRESS_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
			});
			return newState;
		}

		case FETCH_COMPANY_OUTLET_ADDRESS_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.companyOutletAddress.loading = LoadState.InProgress;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ADDRESS_SUCCESS: {
			const { data } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.companyOutletAddress.loading = LoadState.Loaded;
				draftState.companyOutletAddress.data = data;
			});
			return newState;
		}
		case FETCH_COMPANY_OUTLET_ADDRESS_FAILED: {
			const { errorMessage } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.companyOutletAddress.loading = LoadState.Failed;
				draftState.companyOutletAddress.error = errorMessage;
			});
			return newState;
		}
		case CLEAR_COMPANY_OUTLET_ADDRESS: {
			const newState = produce(state, (draftState) => {
				draftState.companyOutletAddress.loading = LoadState.NotLoaded;
				draftState.companyOutletAddress.data = initialCompanyOutletAddress;
			});
			return newState;
		}
		case CLEAR_COMPANY_OUTLET_ADDRESS_STATE: {
			return initialCompanyOutletAddressState;
		}
		default: {
			return state;
		}
	}
};
